/** 助手 tool_payload.brand_site_write：改页写入结果（服务端判定）。 */

export type HermesBrandSiteWritePayload = {
  write_outcome: "applied" | "write_page" | "preview_only" | "none" | string;
  preview_ids?: number[];
  pending_preview_ids?: number[];
  applied_slugs?: string[];
  applied_preview_ids?: number[];
};

export function hermesMessageBrandSiteWriteFromPayload(
  toolPayload: Record<string, unknown> | null | undefined,
): HermesBrandSiteWritePayload | null {
  const raw = toolPayload?.brand_site_write;
  if (!raw || typeof raw !== "object") return null;
  const hash = raw as Record<string, unknown>;
  const writeOutcome = typeof hash.write_outcome === "string" ? hash.write_outcome : "none";
  return {
    write_outcome: writeOutcome,
    preview_ids: coerceIdList(hash.preview_ids),
    pending_preview_ids: coerceIdList(hash.pending_preview_ids),
    applied_slugs: coerceSlugList(hash.applied_slugs),
    applied_preview_ids: coerceIdList(hash.applied_preview_ids),
  };
}

export function isHermesPreviewAlreadyApplied(
  previewId: number,
  previewSlug: string,
  write: HermesBrandSiteWritePayload | null,
): boolean {
  if (!write) return false;
  if (write.applied_preview_ids?.includes(previewId)) return true;
  const slug = previewSlug.trim();
  if (!slug) return false;
  return Boolean(write.applied_slugs?.includes(slug));
}

function coerceIdList(value: unknown): number[] {
  if (!Array.isArray(value)) return [];
  return value
    .map((item) => (typeof item === "number" ? item : Number.parseInt(String(item), 10)))
    .filter((id) => Number.isFinite(id) && id > 0);
}

function coerceSlugList(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  return value.map((item) => String(item).trim()).filter(Boolean);
}
